import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./NewArrivalsHeader.module.css";
var NewArrivalsHeader = function NewArrivalsHeader(_ref) {
  var haveResult = _ref.haveResult;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "new-arrivals-header"
  }, haveResult ? /*#__PURE__*/React.createElement("h1", {
    className: stl.newArrivalsHeader
  }, t("سيارات وصلت حديثا", {
    ns: "new_arrivals"
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: stl.newArrivalsHeader
  }, t("نعتذر!", {
    ns: "new_arrivals"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.newArrivalsDescription
  }, t("السيارات التي تطابق مفضلتك قد تم بيعها. نقترح عليك سيارات مشابهة اخرى", {
    ns: "new_arrivals"
  }))));
};
export default NewArrivalsHeader;